import React, { lazy, Suspense, useState, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@material-ui/styles";
import { makeStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { connect } from "react-redux";
import { inicializarAnalytics } from "./shared/utils/GoogleAnalytics";
import { obterTemaEmpresa } from "./themes/controladorTema";
import { obterLogoEmpresa } from "./themes/controladorLogo";
import { obterImagemEmpresa } from "./themes/controladorImagem";
import { Helmet } from "react-helmet";
import "./App.css";
import "./ckeditor.css";
import { configureEnvironment } from "./config/env";
import { ambiente } from "../src/shared/utils/enum";
import { obterApelidoEmpresaRota } from "./shared/utils/Formatacao";
import PollingTempoExpiracao from "./shared/layout/TempoExpiracao/PollingTempoExpiracao";
import { listarEmpresasHelp, obterDadosEmpresa } from "./themes/Manager/EmpresaManager";
import { HELP_MYPARDINI } from "./shared/utils/Constantes";

const Routes = lazy(() => import("./Routes"));
const apelidoUrlMyPardini = "mypardini";
const queryClient = new QueryClient();
const useStyles = props => makeStyles({ "@global": props.global }, { index: 1 });

function App(props) {
  const { estaAutenticado, ehMyPardini, usuario, obterEmpresa, listarEmpresasHelp } = props;

  const logoPardini = obterLogoEmpresa({ id: 1 }, ehMyPardini);
  const [tema, setTema] = useState(obterTemaEmpresa({ id: 1 }));
  const [logo, setLogo] = useState(logoPardini);
  const [favicon, setFavicon] = useState(obterImagemEmpresa({ id: 1 }, ehMyPardini));
  const [dadosEmpresa, setDadosEmpresa] = useState(null);

  const rota = decodeURIComponent(window.location.pathname);
  const apelidoEmpresaRota = obterApelidoEmpresaRota(rota);

  useStyles(tema)();

  const idEmpresa = usuario?.empresa?.id || (ehMyPardini || apelidoEmpresaRota ? null : 1);

  const ambienteHomologacao = Boolean(
    configureEnvironment().REACT_APP_NOME_AMBIENTE.codigo === ambiente.homologacao.codigo
  );

  const consultarEmpresa = (ehMyPardini, idEmpresa, apelidoEmpresaRota) => {
    if (!idEmpresa && !apelidoEmpresaRota) {
      return false;
    }

    if (ehMyPardini) {
      return false;
    }

    if (idEmpresa === HELP_MYPARDINI.ID || apelidoEmpresaRota === apelidoUrlMyPardini) {
      return false;
    }

    return true;
  };

  useEffect(() => {
    const obterDadosEmpresa = async () => {
      const empresa = consultarEmpresa(ehMyPardini, idEmpresa, apelidoEmpresaRota)
        ? await obterEmpresa(apelidoEmpresaRota, idEmpresa)
        : { apelidoUrl: apelidoUrlMyPardini };
      setDadosEmpresa(empresa);
      const theme = obterTemaEmpresa(empresa, ehMyPardini);

      setTema(theme);
      setLogo(obterLogoEmpresa(empresa, ehMyPardini));
      setFavicon(obterImagemEmpresa(empresa, ehMyPardini));
      inicializarAnalytics(!ehMyPardini && empresa ? empresa.gtm : null);
      await listarEmpresasHelp();
    };

    obterDadosEmpresa();
  }, [idEmpresa, ehMyPardini]);

  const renderLoader = () => <p>Carregando</p>;

  if (!dadosEmpresa || !tema || !logo) {
    return renderLoader();
  }

  return (
    <ThemeProvider theme={tema}>
      <QueryClientProvider client={queryClient}>
        <PollingTempoExpiracao />
        <Helmet>
          {ambienteHomologacao ? <title>HOMOL - Help de Exames</title> : ""}
          <img src={favicon.icon}></img>
          <link rel="icon" href={favicon.icon} />
          <link rel="apple-touch-icon" href={favicon.icon} />
        </Helmet>
        <CssBaseline />
        <Suspense fallback={renderLoader()}>
          <Routes
            estaAutenticado={estaAutenticado}
            dadosUsuario={usuario}
            logo={logo}
            dadosEmpresa={dadosEmpresa}
          />
        </Suspense>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

const mapStateToProps = state => {
  return {
    estaAutenticado: state.login.usuario != null,
    usuario: state.login.usuario,
    ehMyPardini: (state.login && state.login.usuario && state.login.usuario.ehMyPardini) ?? false
  };
};

const mapDispatchToProps = {
  obterEmpresa: (apelidoEmpresa, idEmpresa) => obterDadosEmpresa(apelidoEmpresa, idEmpresa),
  listarEmpresasHelp: () => listarEmpresasHelp()
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
